function loadScript(src) {
  return new Promise((resolve) => {
    const scriptElement = document.createElement('script');
    scriptElement.setAttribute('src', src);
    scriptElement.onload = () => resolve();

    document.head.appendChild(scriptElement);
  });
}

export default loadScript;
